/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/12/2021
 */

import CalendarItem from "@shared/integrations/calendar/CalendarItem";
import {CalendarTypeEnum} from "@shared/integrations/calendar/CalendarTypeEnum";

export default class iCalCalendarItem extends CalendarItem {


	constructor() {
		super(CalendarTypeEnum.ICAL);
	}
}
